// extracted by mini-css-extract-plugin
export default {"wrapper":"customRenderValue_wrapper__vhJgB","count":"customRenderValue_count__XxGRA"};